import React from 'react';
import { NavLink } from 'react-router-dom';

interface RouteInfo {
    href: string;
    name: string;
    title: string;
    image: string;
}

interface NavElemProps {
    routeInfo: RouteInfo;
}

function NavElem({ routeInfo }: NavElemProps) {
    const handleClick = () => {
        // Вызываем вибрацию через Telegram Web App API
        if (window.Telegram?.WebApp) {
            window.Telegram.WebApp.HapticFeedback.impactOccurred('light');
        }
    };

    return (
        <NavLink 
            to={routeInfo.href}
            className={({ isActive }: { isActive: boolean }) => `nav-elem ${isActive ? 'active' : ''}`}
            onClick={handleClick}
        >
            <img 
                className={`nav-icon ${routeInfo.name === 'Subscription' ? 'subscription-icon' : ''}`}
                src={routeInfo.image} 
                alt={routeInfo.title}
                style={routeInfo.name === 'Subscription' ? { transform: `scaleX(var(--flip-direction, 1))` } : undefined}
            />
            <div className="nav-title">{routeInfo.title}</div>
        </NavLink>
    );
}

export default NavElem; 